var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-primary font-medium",attrs:{"href":_vm.href,"target":_vm.target,"textColor":''},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[(_vm.btnIcon)?_c('i',{class:_vm.btnIcon}):_vm._e(),_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }